import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { IntroBreaker } from './components/IntroBreaker';
import { ImageBreaker } from './components/ImageBreaker';
import { LocationSection } from './components/LocationSection';
import { StatsSection } from './components/StatsSection';
import { FloorsSection } from './components/FloorsSection';
import { Slideshow } from './components/Slideshow';
import { FeatureGallery } from './components/FeatureGallery';
import { ContactSection } from './components/ContactSection';
import { CustomCursor } from './components/CustomCursor';
export function App() {
  useEffect(() => {
    document.title = 'Jrp Homes • Campanilla, Ayala Westgrove Heights';
  }, []);
  return <main id="top" className="relative w-full min-h-screen overflow-x-hidden bg-bg-warm text-text-primary" data-id="element-0">
      <CustomCursor data-id="element-1" />
      <Navbar data-id="element-2" />
      <HeroSection data-id="element-3" />
      <IntroBreaker data-id="element-4" />
      <ImageBreaker data-id="element-5" />
      <LocationSection data-id="element-6" />
      <StatsSection data-id="element-7" />
      <FloorsSection data-id="element-8" />
      <FeatureGallery data-id="element-9" />
      <Slideshow data-id="element-10" />
      <ContactSection data-id="element-11" />

      <footer className="py-8 text-center border-t border-black/5 relative z-10 bg-bg-warm" data-id="element-12">
        <p className="text-xs text-text-muted font-light tracking-wide" data-id="element-13">
          © 2026 JRP Homes. All rights reserved.
        </p>
      </footer>
    </main>;
}